// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ultimate-security-form-wrapper {
  background-color: #ffffff;
}
@media (min-width: 1200px) {
  .ultimate-security-form-wrapper {
    margin-left: 160px;
    margin-right: 160px;
  }
}
.ultimate-security-form-wrapper .form-container {
  width: 100%;
  max-width: 688px;
  margin-left: auto;
  margin-right: auto;
}
.ultimate-security-form-wrapper .form-container .form-card {
  background-color: #FFFFFF;
  border: 1px solid #D8D9DB;
  border-radius: 3px;
  padding: 24px;
}
.ultimate-security-form-wrapper .form-container .form-card.promo-card {
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
.ultimate-security-form-wrapper .form-container .form-card.promo-card .card-image {
  display: inline-block;
  margin-bottom: 24px;
}
.ultimate-security-form-wrapper .form-container .form-card.promo-card .card-title {
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1%;
  margin: 0;
  margin-bottom: 12px;
}
.ultimate-security-form-wrapper .form-container .form-card.promo-card .card-intro {
  color: #000000;
  margin-bottom: 24px;
}
.ultimate-security-form-wrapper .form-container .form-card.promo-card .card-link {
  font-weight: 600;
  color: #873EFF;
  text-decoration: none;
}
.ultimate-security-form-wrapper .form-container .form-card.form-area {
  margin-bottom: 40px;
}
.ultimate-security-form-wrapper .form-container .form-card.form-area .form-title {
  font-weight: 600;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: 1%;
  text-align: center;
  margin-bottom: 24px;
}
.ultimate-security-form-wrapper .form-container .form-card.form-area .form-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ultimate-security-form-wrapper .form-container .form-card.form-area .form-row label {
  display: block;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1%;
}
.ultimate-security-form-wrapper .form-container .form-card.form-area .form-row .form-input {
  border: 1px solid #D8D9DB;
  background-color: #FFFFFF;
  border-radius: 3px;
  padding: 10px;
  width: 100%;
  max-width: unset;
}
.ultimate-security-form-wrapper .form-container .form-card.form-area .form-row + .form-row {
  margin-top: 24px;
}
.ultimate-security-form-wrapper .form-container .form-notice {
  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 30px;
  /* PL Color Guideline (Theme + Plugin)/Colors/Primary */
  background: #EBEBF4;
  /* PL Color Guideline (Theme + Plugin)/Purple/90 */
  border: 1px solid #2C045D;
  border-radius: 3px;
  gap: 16px;
  margin-top: 40px;
}
.ultimate-security-form-wrapper .form-container .form-notice .notice-icon {
  flex: 0 0 48px;
}
.ultimate-security-form-wrapper .form-container .form-notice .notice-icon img {
  width: 100%;
  height: auto;
}
.ultimate-security-form-wrapper .form-container .form-notice .notice-content {
  flex: 1;
}
.ultimate-security-form-wrapper .form-container .form-notice .notice-content .notice-title {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  letter-spacing: 0.01em;
  /* PL Color Guideline (Theme + Plugin)/Purple/90 */
  color: #2C045D;
  margin: 0;
  margin-bottom: 8px;
}
.ultimate-security-form-wrapper .form-container .form-notice .notice-content .notice-intro {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */
  letter-spacing: 0.01em;
  /* PL Color Guideline (Theme + Plugin)/Purple/90 */
  color: #2C045D;
}`, "",{"version":3,"sources":["webpack://./src/pages/ContactForm/ContactForm.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;AAAI;EAFJ;IAGQ,kBAAA;IACA,mBAAA;EAGN;AACF;AAFI;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAIR;AAHQ;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAKZ;AAJY;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAMhB;AALgB;EACI,qBAAA;EACA,mBAAA;AAOpB;AALgB;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;AAOpB;AALgB;EACI,cAAA;EACA,mBAAA;AAOpB;AALgB;EACI,gBAAA;EACA,cAAA;EACA,qBAAA;AAOpB;AAJY;EACI,mBAAA;AAMhB;AALgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAOpB;AALgB;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAOpB;AANoB;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAQxB;AANoB;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AAQxB;AANoB;EACI,gBAAA;AAQxB;AAHQ;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EAEA,uDAAA;EACA,mBAAA;EACA,kDAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AAIZ;AAHY;EACI,cAAA;AAKhB;AAJgB;EACI,WAAA;EACA,YAAA;AAMpB;AAHY;EACI,OAAA;AAKhB;AAJgB;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,sBAAA;EAEA,kDAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AAKpB;AAHgB;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EAEA,kDAAA;EACA,cAAA;AAIpB","sourcesContent":[".ultimate-security-form-wrapper {\n    background-color: #ffffff;\n    @media (min-width: 1200px) {\n        margin-left: 160px;\n        margin-right: 160px;        \n    }\n    .form-container {\n        width: 100%;\n        max-width: 688px;\n        margin-left: auto;\n        margin-right: auto;\n        .form-card {\n            background-color: #FFFFFF;\n            border: 1px solid #D8D9DB;\n            border-radius: 3px;\n            padding: 24px;\n            &.promo-card {\n                text-align: center;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                .card-image {\n                    display: inline-block;\n                    margin-bottom: 24px;\n                }\n                .card-title {\n                    color: #000000;\n                    font-weight: 600;\n                    font-size: 16px;\n                    line-height: 24px;\n                    letter-spacing: 1%;\n                    margin: 0;\n                    margin-bottom: 12px;\n                }\n                .card-intro {\n                    color: #000000;\n                    margin-bottom: 24px;\n                }\n                .card-link {\n                    font-weight: 600;\n                    color: #873EFF;\n                    text-decoration: none;\n                }\n            }\n            &.form-area {\n                margin-bottom: 40px;\n                .form-title {\n                    font-weight: 600;\n                    font-size: 28px;\n                    line-height: 34px;\n                    letter-spacing: 1%;\n                    text-align: center;\n                    margin-bottom: 24px;\n                }\n                .form-row {\n                    display: flex;\n                    flex-direction: column;\n                    gap: 8px;\n                    label {\n                        display: block;\n                        font-weight: 600;\n                        font-size: 16px;\n                        line-height: 24px;\n                        letter-spacing: 1%;\n                    }\n                    .form-input {\n                        border: 1px solid #D8D9DB;\n                        background-color: #FFFFFF;\n                        border-radius: 3px;\n                        padding: 10px;\n                        width: 100%;\n                        max-width: unset;\n                    }\n                    + .form-row  {\n                        margin-top: 24px;\n                    }\n                }\n            }\n        }\n        .form-notice {\n            /* Auto layout */\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            padding: 30px;\n\n            /* PL Color Guideline (Theme + Plugin)/Colors/Primary */\n            background: #EBEBF4;\n            /* PL Color Guideline (Theme + Plugin)/Purple/90 */\n            border: 1px solid #2C045D;\n            border-radius: 3px;\n            gap: 16px;\n            margin-top: 40px;\n            .notice-icon {\n                flex: 0 0 48px;\n                img {\n                    width: 100%;\n                    height: auto;\n                }\n            }\n            .notice-content {\n                flex: 1;\n                .notice-title {\n                    font-style: normal;\n                    font-weight: 700;\n                    font-size: 16px;\n                    line-height: 24px;\n                    /* identical to box height, or 150% */\n                    letter-spacing: 0.01em;\n\n                    /* PL Color Guideline (Theme + Plugin)/Purple/90 */\n                    color: #2C045D;\n                    margin: 0;\n                    margin-bottom: 8px;\n                }\n                .notice-intro {\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 20px;\n                    /* or 143% */\n                    letter-spacing: 0.01em;\n\n                    /* PL Color Guideline (Theme + Plugin)/Purple/90 */\n                    color: #2C045D;\n\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
